<style>
.vue-daterange-picker .ranges {
  float: right;
  border-left: 1px solid #ddd;
}
.reportrange-text{
  border-radius: 10px;
}
.btn-dowload{
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
}
</style>
<template>
  <div class="card_view bg-transparent timeLine-card">
    <div class="vx-row">
      <div class="vx-card w-full p-2 pt-0">
        <div class="vx-row ml-0">
          <div class="vx-col md:w-3/12 header_tab w-full mt-2">
            <span class="title_tab">{{$t('articleBookmark.project')}}:</span>
            <div>
              <v-select style="width: 70%;" class="text-size w-full" v-model="projectSelected" :options ="optionGroupTopics" @input="findByGroup" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>
          </div>
          <div class="vx-col w-full md:w-3/12 header_tab mt-2">
            <span class="title_tab">{{$t('articleBookmark.topics')}}:</span>
            <div>
              <v-select style="width: 70%;" class="text-size w-full" v-model="topicSelected" :options ="optionalsTopic" @input="findByTopicId" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>
          </div>
          <div class="vx-col w-full md:w-4/12 header_tab vx-col mt-2" style="border-right:1px solid #ccc">
            <span class="title_tab">{{$t('realtimeChart.boxTime')}}:</span>
            <date-range-picker
              class="w-full"
              ref="picker"
              :locale-data="{format: 'dd/mm/yyyy' }"
              :opens="'left'"
              @update="loadData"
              v-model="dateRange">
            </date-range-picker>
          </div>
          <div class="vx-col w-full md:w-2/12 btn-dowload mt-2" >
            <vs-button
              class="w-full"
              icon="icon-download"
              icon-pack="feather"
              style="border-radius:10px"
              @click="exportExcel">
              {{ $t("download") }}
            </vs-button>
        </div>
        </div>
    </div>
    </div>
    <div class="vx-row">
      <div style="overflow: auto;">
        <div class="vx-row mt-4 pl-4" style="flex-wrap: nowrap;">
          <div v-for="(item,index) in dayList" :key="index"  class="vx-col p-0 md:w-1/6" style="min-width:200px">
            <div class="w-full p-4" style="background-color: #F3F2F7;display: flex;justify-content: center;">
              <span class="font-semibold" style="letter-spacing: 1px">{{item.dateTime}}</span>
            </div>
            <div v-for="(itemX,index) in item.rowDatas" class="vx-row ml-0 card_view mt-1" style="height: 46px;">
              <div v-if="itemX.classification == 1" style="width: 5px; background-color: blue;height: 46px;"></div>
              <div v-if="itemX.classification == -1" style="width: 5px; background-color: red;height: 46px;"></div>
              <div v-if="itemX.classification == 0" style="width: 5px; background-color: gold;height: 46px;"></div>
              <div class="hide_title pl-2 pt-2" style="width: 70%;">
                <a :href="itemX.url" target="_blank" style = "color: rgb(98, 98, 98)"><span>{{itemX.title}}</span></a>
              </div>
              <div style="width: 25%;display: flex;align-items: center;justify-content: flex-end">
                <span style="font-size: 12px;color: #b1a5a5d9;">{{itemX.dateTime}}</span>
              </div>
            </div>
            <div v-if="item.totalElements > 0" class="vx-col mt-4 mb-4">
              <div style="display: flex;justify-content: center"><span class="font-semibold" style="font-size: 12px">{{displayNumber(item.totalElements)}} {{$t('articleTimeLine.post')}}</span></div>
              <div style="display: flex;justify-content: center"><span @click="openNews(item)" class="underline text-primary cursor-pointer" style="font-size:12px">{{$t('articleTimeLine.postLink')}}</span></div>
            </div>
            <div v-else class="vx-col mt-4 mb-4">
              <div style="display: flex;justify-content: center"><span class="font-semibold" style="font-size: 12px"> 0 {{$t('articleTimeLine.post')}}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker';
import authConfig from '@/../auth_config.json';
import NoImage from '@/assets/images/logo/no_image.png';
import emoji from '@/assets/images/icon-facebook/emoji.png';
import like from '@/assets/images/icon-facebook/like.png';
import love from '@/assets/images/icon-facebook/love.png';
import care from '@/assets/images/icon-facebook/care.png';
import haha from '@/assets/images/icon-facebook/haha.png';
import wow from '@/assets/images/icon-facebook/wow.png';
import sad from '@/assets/images/icon-facebook/sad.png';
import angry from '@/assets/images/icon-facebook/angry-face.png';
import DateRangePicker from '@/layouts/components/vue2-daterange-picker/components/DateRangePicker.vue'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  name: "ArticleTimeLine",
  components:{
    vSelect,
    Datepicker,
    NoImage,
    DateRangePicker,
    VueSimpleSuggest,
    authConfig,
    VuePerfectScrollbar
  },
  props: {
    initial: {
      default: true
    },
    showFacebookProfile:{default:true},
    showFacebookComment:{default:true},
    showNewsPost:{default:true},
    showTopic: {default: true},
    topicId: {},
    selectedTopic: {},
    classification: {default:null},
    facePost:{},
    faceComment:{},
    newsPost:{},
    getAll:{default:true},
    labelNews:{default:false},
    labelSocial:{default:false},
    showNewsPostDetail: {default:false},
    showFilterCase:{default:true},
    refreshData:{default:0},
    showYoutube:{default:true},
    showYoutubeComment:{default:true},
    showForum: {default:true},
    showForumComment:{default:true},
    showGoogle:{default:true}
  },
  computed:{
    topicSelected:{
      get(){
        let label = null;
        let object = this.optionalsTopic.find(el => el.value === this.topicName);
        if(!object){
          return null
        }
        if(object && object.label.length > 13){
          label = object.label.slice(0,13) + '...';
        }
        else{
          label = object.label;
        }

        return {
          label:label,
          value:this.topicName,
          topicGroupId:this.topicGroupId
        }
      },
      set(object){
        if(!object){
          this.topicName = null;
        }
        else{
          this.topicName = object.value
        }
      }
    },
    projectSelected:{
      get(){
        let label = null;
        let object = this.optionGroupTopics.find(el => el.value === this.groupName);
        if(!object){
          return null
        }
        if(object && object.label.length > 25){
          label = object.label.slice(0,25) + '...';
        }
        else{
          label = object.label;
        }

        return {
          label:label,
          value:this.groupName
        }
      },
      set(object){
        if(!object){
          this.groupName = null;
        }
        else{
          this.groupName = object.value
        }
      }
    }
  },
  data(){
    return {
      sizeContentByScreen: 8,
      optionGroupTopicsOrigin:[],
      dayList:[],
      originTopic:[],
      topicGroupId:null,
      groupName:null,
      optionalSort:[
        {label:'Tin mới nhất', value:0},
        {label:'Tin cũ nhất', value:1},
        {label:'Mức độ tăng dần', value:2},
        {label:'Mức độ giảm dần', value:3},
      ],
      valueOption: null,
      selected:[],
      checkBoxGoogle:true,
      checkBoxForum:true,
      checkBoxYoutube:true,
      checkBoxNews:true,
      checkBoxFaceComment:true,
      checkBoxFacePost:true,
      checkBoxAllSocial:true,
      checkBoxAllNews:true,
      checkBoxAllData:true,
      checkBoxPositive:true,
      checkBoxNegative:true,
      checkBoxNeutral:true,
      selectedContent:false,
      simpleSuggestionList:[],
      loadDataNofity:0,
      pageNumber: 0,
      panel: 'range',
      topic:null,
      gropName:{},
      optionalsTopic:[],
      optionGroupTopics:[],
      userTopics:[],
      valueText:null,
      valueOldestPost:null,
      valueInteractive:null,
      valueInteractiveUp:null,
      radio:"SmileIcon",
      date:null,
      optionalsValue:"Tất cả chủ đề",
      checkbox:false,
      valueCheckbox:[],
      searchByIdAndName:null,
      currentItemView:'item-list-view',
      checkBox:false,
      rowDatas:[],
      pageNumbers:null,
      totalPages:0,
      perPage:10,
      maxPageNumbers:6,
      lastPage: 1,
      currentPage:1,
      gridApi:null,
      popupActive:false,
      dialogName:null,
      titleDialog:null,
      bookmark:true,
      star:false,
      valueRadio:null,
      filter: true,
      responseDataTopic:[],
      topicName:null,
      rangeDate:null,
      formData:{
        url:null,
        title:null,
        fullContents:null,
        publishDateForm:null,
        name:null,
        img:null,
        keyword:null,
        fromDate:null,
        toDate:null,
        isSpam:false,
        isBookMark:false,
        id:null,
        optionalNegative:[],
        optionalNeutral:[],
        optionalPositive:[],
        beanType:null,
        classification:null,
        percentNegative:null,
        percentNeurtal:null,
        percentPositive:null,
        activeClassification:false
      },
      userName:[],
      totalElements:null,
      beanType:null,

      // checkbox
      dataCheckBox:false,
      dataCheckBox2:false,
      dataCheckBox3:false,
      valueCheckBoxClassification:null,
      pooledNews:null,
      newsPostCheckBox: false,
      facePostCheckBox: false,
      faceCommentCheckBox: false,
      findAll:false,
      youtubeCheckBox:false,
      forumCheckbox:false,
      googleCheckbox:false,
      otherCheckboxFacebook:[],
      checkIndexOther:null,

      //Date
      dateNow :null,

      //value text classification
      valueTextPositive:null,
      valueTextNegative:null,
      valueTextInter:null,
      valueTextAll:null,
      valueTextUndefined:null,

      offset:null,
      pageSize:null,
      totalContent:0,

      //classification
      item:null,
      origin:null,
      spam:false,

      //Spam
      itemSpam:null,
      News:false,
      Social:false,

      //hover
      active:false,
      reactionItem:[
        {text: 'all', icon: emoji, label: this.$t('articleBookmark.all')},
        {text: 'like', icon:like,label: this.$t('articleBookmark.like')},
        {text: 'love', icon:love,label: this.$t('articleBookmark.love')},
        {text: 'haha', icon:haha,label:'Haha'},
        {text: 'wow', icon:wow,label: this.$t('articleBookmark.wow')},
        {text: 'care', icon:care,label: this.$t('articleBookmark.care')},
        {text: 'sad', icon:sad,label: this.$t('articleBookmark.sad')},
        {text: 'angry', icon:angry,label: this.$t('articleBookmark.angry')}
      ],
      labelReaction: this.$t('articleBookmark.all'),
      selectedAngry:null,
      selectedCare:null,
      selectedHaha:null,
      selectedLike:null,
      selectedLove:null,
      selectedSad:null,
      selectedWow:null,
      iconFilter:null,

      dateRange: {
        endDate: new Date(),
        startDate: (() => { let date = new Date ();
          date.setDate(date.getDate() - 6);
          date.setHours(0,0,0);
          return date
        })()
      },
      settings: {
        wheelSpeed: .30,
        suppressScrollX: true
      },
      otherCheckbox:[],
      sourceData:[],
      dataItem:[]
    }
  },
  methods:{
    exportExcel: function() {
      const detail = localStorage.getItem("userInfo");
      const user = JSON.parse(detail);
      const payload = {
        userId: user.id,
        startDate: this.dateRange.startDate,
        endDate: this.dateRange.endDate,
        topicId: this.topicId,
        groupId: this.groupName
      };
      500
      let url = 'statisticals/export-data';
      if (user.id == 500) {
        url = 'statisticals/export-data-vp-template';
      }
      let packageApiPermission = this.$root.businessPackage.permissions.reduce((arr,item) => {
        arr.push(...item.functionApiPrefix.split(";"))
        return arr;
      }, []);
      let apiPermission = this.$root.permissionList.reduce((arr,item) => {
        arr.push(...item.functionApiPrefix.split(";"))
        return arr;
      }, []);
      if (apiPermission.includes(url) && !packageApiPermission.includes(url)) {
        return this.$vs.notify({
          text: this.$t('noPermission'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      }
      this.$vs.loading();
      this.$report
        .post(url, payload)
        .then(response => {
          this.$vs.loading.close();
          if (!response || !response.data) return this.$vs.notify({
            text: this.$t('createReportError'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
          window.open(
            authConfig.reportDomain +
            "download/" +
            response.data +
            "?access_token=" +
            localStorage.getItem("access_token"),
            "_blank"
          );
          this.$vs.loading.close();
          return this.$vs.notify({
            text: this.$t("dashboardAnalytics.textSuccess"),
            icon: "icon-alert",
            iconPack: "feather",
            color: "primary"
          });
        })
        .catch(err => {
          this.$vs.loading.close();
          return this.$vs.notify({
            text:
              err.response.data.message ||
              err.response.data.error_description ||
              err.response.data.error,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        });
    },
    displayNumber(number){
      if (number > 99) {
        return '99+'
      }
      else {
        return number
      }
    },
    openNews:function (item){
      let id = this.topicName;
      let fromDate = item.date
      this.$router.push(`/user/article-details-v2?start=${fromDate}&id=${id}`).catch(()=>{});
    },
    getTopicGroups: function(){
      return new Promise((resolve,reject) =>{
        this.$business.post('/topic-group/find-by-conditions',{}).then((res) =>{
          this.optionGroupTopics= res.data;
          if(this.optionGroupTopics.length > 0){
            this.optionGroupTopics = this.optionGroupTopics.map(el =>{
              if(el.groupName && el.groupName.length > 25){
                el.groupName = el.groupName.slice(0,25) + '...';
              }
              return {
                label:el.groupName,
                value:el.id
              }
            })
            if (this.groupName) {
              let selectedItem = this.optionGroupTopics.find(item => item.value == this.groupName)
              if (selectedItem) this.optionGroupTopics = selectedItem;
            }
            this.optionGroupTopics.unshift({label: this.$t('articleBookmark.all'),
              value: null})
          }
          this.optionGroupTopicsOrigin = this.optionGroupTopics;
          resolve();
        }).catch(() => reject())
      })
    },
    getDataSource: function(){
      const payload = {
        pageNumber: 0,
        pageSize: 20
      }
      this.$processor.post('website/get-all', payload).then((response) => {
        this.sourceData = response.data.content;
        this.sourceData.forEach(el => el.checkBoxOther = true);
        this.sourceData = this.sourceData.filter(el => el.activeWebsite == true);
        this.lengthSourceData=this.sourceData.length;
      })
    },
    directionNews: function(event){
      window.open(event.link, "_blank");
    },
    validURL: function(str) {
      var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
        '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
      return !!pattern.test(str);
    },
    imgError(image){
      image.target.src = NoImage;
    },
    highlight: function(text){
      let inputText = document.getElementById("inputText");
      let innerHTML = inputText.innerHTML;
      let index = innerHTML.indexOf(text);
      if(index >= 0){
        innerHTML = innerHTML.substring(0,index) + "<span class ='highlight'>" + innerHTML.substring(index, index+ text.length) + "</span>" + innerHTML.substring(index +text.length);
        inputText.innerHTML = innerHTML;
      }
    },
    // Facebook-API
    loadData: function(){
      this.$vs.loading();
      let startDate =  moment(this.dateRange.startDate).format("YYYY/MM/DD");
      let endDate = moment(this.dateRange.endDate).format("YYYY/MM/DD");
      if (this.$i18n.locale == 'vn') {
        this.dayList = getDates(startDate, endDate);
      } else {
        this.dayList = getDatesEN(startDate, endDate);
      }
      let payload ={
        pageNumber: this.pageNumber,
        pageSize: this.sizeContentByScreen,
        userDataElasticsearch:{classification: this.classification, topicId: this.topicId ? this.topicId : null, isSpam:false},
        recently: this.valueText,
        oldestPost: this.valueOldestPost,
        interactive:this.valueInteractive,
        interactiveAscending: this.valueInteractiveUp,
        newsPost: this.newsPostCheckBox ? 101:0,
        facePost: this.facePostCheckBox ? 104: 0,
        faceComment: this.faceCommentCheckBox ? 105:0,
        youtube:this.youtubeCheckBox ? 106 : 0,
        youtubeComment:this.youtubeCheckBox ? 107 : 0,
        forum: this.forumCheckbox ? 111 : 0,
        forumComment:this.forumCheckbox ? 112 : 0,
        google: this.googleCheckbox ? 113 : 0,
        domain: this.otherCheckbox,
        domainFacebook: this.otherCheckboxFacebook,
        fromDate: new Date(this.dateRange.startDate.setHours(0, 0, 0)),
        toDate: new Date(this.dateRange.endDate.setHours(23, 59, 59)),
        content: this.formData.keyword,
        hahaCount: this.selectedHaha,
        likeCount: this.selectedLike,
        loveCount: this.selectedLove,
        sadCount: this.selectedSad,
        wowCount: this.selectedWow,
        careCount: this.selectedCare,
        angryCount: this.selectedAngry,
        positive:this.checkPositive,
        neutral:this.checkNeutral,
        negative: this.checkNegative,
        groupId: this.groupName,
      }
      if (!payload.newsPost && !payload.facePost && !payload.faceComment && !payload.youtube && !payload.youtubeComment && !payload.forum && !payload.forumComment && !payload.google) {
        if (this.showFacebookProfile != "false") payload.facePost = 104
        if (this.showFacebookComment != "false") payload.faceComment = 105
        if (this.showNewsPost != "false") payload.newsPost = 101
        if(this.showYoutube != 'false') {payload.youtube  = 106; payload.youtubeComment = 107}
        if(this.showForum != 'false') {payload.forum = 111; payload.forumComment  = 112}
        if(this.showGoogle != false) payload.google =  113
      }
      for(let i = 0 ; i < this.dayList.length; i++) {
        let startTime = moment(this.dayList[i].date, "YYYY-MM-DD");
        let endTime = moment(this.dayList[i].date, "YYYY-MM-DD").set(
          {hour:23,minute:59,second:59}
        );
        ((index, startTime, endTime)=>{
          let requestObj = JSON.parse(JSON.stringify(payload))
          requestObj.fromDate = startTime;
          requestObj.toDate = endTime;
          this.$processor.post('/user-data/find-by-condition', requestObj).then(response => {
            this.$vs.loading.close();
            this.dayList[index].totalElements = response.data.totalElements
            this.dayList[index].rowDatas.push(...response.data.content.map(el => {
              if (el.domain) {
                let name = el.domain.split("//").pop().replace("www.", "");
                if (name.length > 15) {
                  el.domainName = name.slice(0, 15) + '...';
                } else {
                  el.domainName = name;
                }
              }
              if (el.publishDate) {
                let time = new Date(el.publishDate);
                let dateTime = time.getHours();
                let dateMinu = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()
                el.dateTime = dateTime + ":" + dateMinu;
                el.publishDate = moment(el.publishDate).format("YYYY-MM-DD");
              }
              if (el.fullContents && el.fullContents.length > 0) {
                el.displayFullContent = el.fullContents.filter(item => item.type == "text").map((elements) => {
                  if (elements.content) {
                    return elements.content.trim();
                  }
                }).join("\n");
              }
              if (el.url) {
                el.link = el.url;
              }
              if (el.specialFields.from) {
                let username = JSON.parse(el.specialFields.from);
                el.name = username.name;
              }
              if (el.attachmentUrls && el.attachmentUrls.length > 0) {
                let attachmentUrl = el.attachmentUrls[0];
                el.image = attachmentUrl.url;
              }
              if (el.specialFields.reactionCount >= 0) {
                el.reaction = el.specialFields.reactionCount;
              }
              if (el.specialFields.likeCount >= 0 && el.reaction > 0) {
                el.like = el.specialFields.likeCount;
                el.like_percent = (el.like / el.reaction * 100).toFixed(1)
              }
              if (el.specialFields.commentCount >= 0) {
                el.comment = el.specialFields.commentCount;
              }
              if (el.specialFields.shareCount >= 0) {
                el.share = el.specialFields.shareCount;
              }
              if (el.specialFields.commentCount >= 0) {
                el.commentWebsite = el.specialFields.commentCount;
              }
              if (el.specialFields.author) {
                el.name = el.specialFields.author.trim();
              }
              if (el.beanType) {
                this.beanType = el.beanType;
              }
              if (el.specialFields && el.specialFields.channel_title) {
                el.titleYoutube = el.specialFields.channel_title;
              }
              if (el.specialFields && el.specialFields.from) {
                let name = JSON.parse(el.specialFields.from);
                el.userNameForum = name.author;
              }
              if (el.negative && el.normal && el.positive) {
                const total = el.positive + el.negative + el.normal;
                el.percentPositive = (el.positive / total * 100).toFixed(0);
                el.percentNegative = (el.negative / total * 100).toFixed(0);
                el.percentNeurtal = (el.normal / total * 100).toFixed(0);
                const arr = [];
                const result = (el.positive / total * 10).toFixed(0);
                for (let i = 0; i < result; i++) {
                  arr.push(i);
                }
                el.optionalPositive = arr;

                const arrNeutral = [];
                const resultNeutral = (el.normal / total * 10).toFixed(0);
                for (let i = 0; i < resultNeutral; i++) {
                  arrNeutral.push(i);
                }
                el.optionalNeutral = arrNeutral;

                const arrNegative = [];
                const resultNegative = 10 - (arr.length + arrNeutral.length);
                for (let i = 0; i < resultNegative; i++) {
                  arrNegative.push(i);
                }
                el.optionalNegative = arrNegative
              } else {
                const arr = [];
                const result = 10;
                for (let i = 0; i < result; i++) {
                  arr.push(i);
                }
                if (el.classification == 0) {
                  el.optionalNeutral = arr;
                } else if (el.classification == 1) {
                  el.optionalPositive = arr;
                } else if (el.classification == -1) {
                  el.optionalNegative = arr;
                }
              }
              let totalReaction = [
                {text: 'all', value: el.like, icon: like, label: 'Tất cả', percent: el.like_percent},
                {text: 'like', value: el.like, icon: like, label: 'Thích', percent: el.like_percent},
                {text: 'love', value: el.love, icon: love, label: 'Yêu thích', percent: el.love_percent},
                {text: 'haha', value: el.haha, icon: haha, label: 'Haha', percent: el.haha_percent},
                {text: 'wow', value: el.wow, icon: wow, label: 'Ngạc nhiên', percent: el.wow_percent},
                {text: 'care', value: el.care, icon: care, label: 'Thương thương', percent: el.care_percent},
                {text: 'sad', value: el.sad, icon: sad, label: 'Buồn', percent: el.sad_percent},
                {text: 'angry', value: el.angry, icon: angry, label: 'Phẫn nộ', percent: el.angry_percent}];
              const filter = totalReaction.sort(function (a, b) {
                return a.value - b.value
              });
              this.totalReaction = totalReaction;
              el.highlightReaction = filter[6];
              if (!el.highlightReaction.value) {
                el.highlightReaction = totalReaction[0];
              }
              totalReaction = totalReaction.filter(item => item.text != el.highlightReaction.text);
              el.totalReaction = totalReaction;
              if (el.specialFields.source) {
                el.source = el.specialFields.source;
              }
              if (el.specialFields.source && el.specialFields.source.includes('group')) {
                el.source = 'group'
              }
              if (el.displayFullContent) {
                el.origin = el.displayFullContent;
                if (this.selectedTopic && this.selectedTopic.id) {
                  const listTopic = this.userTopics;
                  this.changeClassificationColor(this.userTopics, el);
                } else {
                  this.changeClassificationColorDetail(this.userTopics, el);
                }
              }
              el.active = false;
              el.activeClassification = false;
              return el;
            }));
            this.$vs.loading.close();
          }).catch(() => {
            this.$vs.loading.close();
          })
        })(i, startTime, endTime);
      }

    },
    onGridReady(){
      if(this.$store.state.windowWidth <= 1024){
        this.maxPageNumbers = 5;
      }
      else{
        this.maxPageNumbers = 7;
      }
      if(this.$store.state.windowWidth > 1024){
        this.gridApi.sizeColumnsToFit();
      }
    },
    onChangePage:function(event){
      if (this.currentPage == this.lastPage) return;
      this.lastPage = event;
      this.$vs.loading();
      this.pageNumber = parseInt(event) -1;
      this.loadData();
      this.$vs.loading.close();
    },
    getValueRadio: function(value){
      switch(value){
        case 'SmileIcon':
          return this.valueRadio = 0;
      }
    },
    getListFacebook: function(){
      this.valueTextAll = this.$t('articleBookmark.all')
      this.valueTextPositive = null;
      this.valueTextNegative = null;
      this.valueTextInter = null;
      this.classification = null;
      this.$vs.loading();
      this.loadData();

    },
    checkedClassificationPositive: function(){
      this.$vs.loading();
      this.valueTextPositive = "Tích cực";
      this.valueTextAll = null;
      this.valueTextNegative = null;
      this.valueTextInter =  null;
      this.valueTextUndefined= null;
      this.classification = 1;
      this.currentPage =1;
      this.loadData();
      this.$vs.loading.close();

    },

    searchByIdAndNameInput: function(){
      if(!this.searchByIdAndName){
        this.getListFacebook();
      }
      else{
        const payload ={
          uid:this.searchByIdAndName
        };
        this.$processor.post('/facebook-queue/find-by-id',payload).then((response) =>{
          this.rowDatas = response.data;
          if(this.rowDatas){
            this.rowDatas.forEach(element => {
              let details = JSON.parse(element.details);
              element.name = details.name;
            });
            this.totalPages = parseInt(response.data.totalPages,10);
            this.pageNumbers = response.data.pageable.pageNumber;
          }
        })
          .catch(() =>{})
      }
    },

    updateClassification: function(payload){
      this.loadDataNofity += 1;
      this.$eventBus.$emit('loadDataNotify',this.loadDataNofity);
      this.$vs.loading();
      const item = this.item;
      item.displayFullContent = item.origin;
      this.$processor.post('/user-data/update-classification',payload).then(() =>{
        this.$vs.loading.close();
        this.changeClassificationColor(this.userTopics,item);
        this.loadData();
      })
    },
    changeClassificationColor: function(userTopic,item){
      if(item.origin){
        for (let topic of userTopic) {
          for (let keyword of topic.keywords) {
            let userKeyword = keyword.keyword
            let keywordIndex = item.displayFullContent.toLowerCase().indexOf(userKeyword.toLowerCase())
            if (keywordIndex >= 0 ) {
              item.displayFullContent = item.displayFullContent.slice(item.displayFullContent.slice(0, keywordIndex).lastIndexOf(".") + 1);

              if(item.classification == 1){
                if(!this.selectedTopic.id || topic.id == this.selectedTopic.id){
                  item.displayFullContent = item.displayFullContent.replace(new RegExp(userKeyword, "ig"), `<b style = "color: #29CC97;font-weight: 500;">${userKeyword}</b>`);
                }
              }
              if(item.classification == -1){
                if(!this.selectedTopic.id || topic.id == this.selectedTopic.id){
                  item.displayFullContent = item.displayFullContent.replace(new RegExp(userKeyword, "ig"), `<b style = "color: rgb(255,0,0);font-weight: 500;">${userKeyword}</b>`);
                }
              }
              if(item.classification == 0){
                if(!this.selectedTopic.id || topic.id == this.selectedTopic.id){
                  item.displayFullContent = item.displayFullContent.replace(new RegExp(userKeyword, "ig"), `<b style = "color: rgba(var(--vs-warning),1);font-weight: 500;">${userKeyword}</b>`);
                }
              }
            }
            // break;
          }
          if (!item.displayFullContent) {
            item.displayFullContent = item.displayFullContent.slice(0, item.displayFullContent.indexOf("."));
          }
        }
      }
    },
    changeClassificationColorDetail: function(userTopic,item){
      if(item.origin){
        for (let topic of userTopic) {
          for (let keyword of topic.keywords) {
            let userKeyword = keyword.keyword
            let keywordIndex = item.displayFullContent.toLowerCase().indexOf(userKeyword.toLowerCase())
            if (keywordIndex >= 0 ) {
              item.displayFullContent = item.displayFullContent.slice(item.displayFullContent.slice(0, keywordIndex).lastIndexOf(".") + 1);

              if(item.classification == 1){
                if(!this.topicSelected.value || topic.id == this.topicSelected.value){
                  item.displayFullContent = item.displayFullContent.replace(new RegExp(userKeyword, "ig"), `<b style = "color: #29CC97;font-weight: 500;">${userKeyword}</b>`);
                }
              }
              if(item.classification == -1){
                if(!this.topicSelected.value || topic.id == this.topicSelected.value){
                  item.displayFullContent = item.displayFullContent.replace(new RegExp(userKeyword, "ig"), `<b style = "color: rgb(255,0,0);font-weight: 500;">${userKeyword}</b>`);
                }
              }
              if(item.classification == 0){
                if(!this.topicSelected.value || topic.id == this.topicSelected.value){
                  item.displayFullContent = item.displayFullContent.replace(new RegExp(userKeyword, "ig"), `<b style = "color: rgba(var(--vs-warning),1);font-weight: 500;">${userKeyword}</b>`);
                }
              }
            }
            // break;
          }
          if (!item.displayFullContent) {
            item.displayFullContent = item.displayFullContent.slice(0, item.displayFullContent.indexOf("."));
          }
        }
      }
    },
    nFormatter:function (num) {
      if (num >= 1000000000) {
        return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'G';
      }
      if (num >= 1000000) {
        return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
      }
      if (num >= 1000) {
        return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
      }
      return num;
    },

    // Topic-API

    getListTopic:function(){
      const payload ={
      };
      return new Promise((resolve, reject) => {
        this.$business.post('/topic/find-by-conditions',payload).then((response) =>{
          this.$business.post(`share-topic/get-all-share`,  payload).then((res) =>{
            const topicShare = res.data.filter(el => el.status == 1);
            this.optionalsTopic = [...response.data,...topicShare];
            this.userTopics = [...response.data,...topicShare];
            const inputSuggest = this.optionalsTopic;
            this.simpleSuggestionList = inputSuggest;
            if(this.optionalsTopic.length > 0){
              this.optionalsTopic = this.optionalsTopic.map(el =>{
                return {
                  label:el.topicName,
                  value:el.id,
                  topicGroupId:el.topicGroupId
                }
              })
              if (this.topicId) {
                let selectedItem = this.optionalsTopic.find(item => item.value == this.topicId)
                if (selectedItem) this.topicSelected = selectedItem;
              }
              this.optionalsTopic.unshift({label: this.$t('articleBookmark.all'),
                value: null})
            }
            this.originTopic = this.optionalsTopic ;

            resolve()
          })
        })
          .catch(() =>{reject()})
      })

    },
    mouseHover: function(item){
      item.active = true;
    },
    mouseLeave: function(item){
      item.active = false;
    },
    mouseHoverClassification: function(item){
      item.activeClassification = true;
    },
    mouseLeaveClassification:function(item){
      item.activeClassification = false;
    },

    // User-API


    //Topic
    findByTopicId: function(item){
      this.$vs.loading();
      if (item) this.topicId = item.value;
      this.$vs.loading();
      this.loadData();
    },
    findByGroup: function (e){
      this.optionalsTopic = this.originTopic;
      if(!e){
        this.optionalsTopic = this.originTopic;
        this.loadData()
      }else {
        this.optionalsTopic = this.optionalsTopic.filter(el=>el.topicGroupId == e.value);
        this.optionalsTopic.unshift({label: this.$t('articleBookmark.all'), value: null})
        this.loadData()
        if(this.optionalsTopic.length == 0){
          this.optionalsTopic = this.originTopic;
          this.optionGroupTopics = this.optionGroupTopicsOrigin;
          this.$vs.notify({
            text: this.$t('articleTimeLine.projectNotTopic'),
            iconPack: 'feather',
            icon: 'icon-alert',
            color: 'danger'
          })
        }
      }
    },
    searchByKeyword: function(){
      this.$vs.loading();
      this.loadData()
    },


    //Date-range-picker
    formatDate: function(val){
      return moment(val).format("DD/MM/YYYY");

    },
    dateFormat: function(classes, date){
      if(!classes.disabled){
        classes.disabled = date.getTime() < new Date();
      }
      return classes;
    },
    updateValues: function(){
      this.loadData();
      this.$vs.loading.close();

    },
    getTopicByOrganizationBranding: function() {
      const result = this.optionGroupTopics;
      this.$vs.loading();
      const payload = {};
      this.$business
        .post(`topic/find-by-conditions`, payload)
        .then(res => {
          this.$business.post(`share-topic/get-all-share`,{}).then((response) => {
            let currentUserName = JSON.parse(localStorage.userInfo).email
            const dataShare = response.data;
            const dataShareTopic = response.data;
            if(dataShare.status == 0){
              dataShareTopic.forEach(key =>{
                key.status = dataShare.status;
              })
            }
            const data = [...res.data, ...dataShareTopic.filter(item => item.status == 0 || item.status == 1)];
            this.statusShare = response.data.status;
            if (res.status == "200") {
              this.countBranding = this.optionalBranding.length;
              this.countProductBranding = this.optionalProductBranding.length;
              this.countPersonalBranding = this.optionalPersonalBrandig.length;
              this.$vs.loading.close();
              this.responseData = data;
              data.forEach(el => {
                el.currentUserName = currentUserName;
                if(el.keywords.length > 2){
                  el.plus = el.keywords.length - 2;
                  el.keyword = el.keywords.map(k => k.keyword).slice(0,2).join(", ");
                }
                else{
                  el.keyword = el.keywords.map(k => k.keyword).join(", ");
                }
                if(el.topicName.length > 25){
                  el.topicName = el.topicName.slice(0,25) + '...';
                }
                el.createdDate = moment(el.createdDate || el.modifiedDate).format("DD/MM/YYYY");
                el.checked = false;
                if (!this.optionGroupTopics.find(item => item.value == el.topicGroupId)) {
                  el.isOther = true
                } else {
                  el.isOther = false
                }
              });
              this.topics = data;
              const countOther= data.filter(item => item.isOther);
              this.countOther = countOther.length;
            }
            let resultFilter = [];
            let checkedShareId = [];
            result.forEach(el => {
              resultFilter = data.filter(topic => el.value == topic.topicGroupId)
              checkedShareId = resultFilter.filter(filter => !filter.shareId);
              // let resultFilterOther = data.filter(topic => el.value != topic.topicGroupId)
              // let checkedShareOther = resultFilterOther.filter(filter => !filter.shareId);
              if(checkedShareId.length > 0){
                el.checkedAll = true;
              }
              if(el.isOther){
                this.checkedSelected = true;
              }
            })
          })
            .catch(err => {
              return this.$vs.loading.close();
            });
        })
    },
    updateI18n: function(){
      this.valueText = this.$t('articleDetail.newsFeed')
      this.valueTextAll = this.$t('articleDetail.all');
    },
    initScreen: function(){
      this.labelReaction = this.$t('articleDetail.all')
      this.valueOldestPost =null;
      this.valueInteractive = null;
      this.classification = null
      this.updateI18n();
      this.valueTextPositive = null;
      this.valueTextNegative = null;
      this.valueInteractiveUp = null;
      this.valueOption = 0;
      if(this.labelSocial){
        this.facePostCheckBox = true;
        this.faceCommentCheckBox = true;
        this.newsPostCheckBox = false;
      }
      if(this.labelNews && !this.facePost && !this.faceComment){
        this.facePostCheckBox = false;
        this.faceCommentCheckBox = false;
        this.newsPostCheckBox = true;
      }
      if(!this.newsPostCheckBox && !this.facePostCheckBox && !this.faceCommentCheckBox && !this.youtubeCheckBox && !this.forumCheckbox && !this.googleCheckBox){
        this.findAll = true;
      }
      if(this.showFacebookProfile == true && this.showFacebookComment == true){
        this.findAll = true;
        this.faceCommentCheckBox = false;
        this.facePostCheckBox = false;
      }
      if(this.showNewsPost == true){
        this.findAll = true;
        this.newsPostCheckBox = false;
      }
      this.getListTopic().then(()=>{
        if (this.initial) {
          this.loadData();
        }
        this.getDataSource();
      });
      this.getTopicGroups().then(() =>{
        if (this.initial) {
          this.loadData();
        }
      });

      this.getDataSource();
    },
    exportFile: function (){

      this.$vs.loading();
      let payload ={
        pageNumber: this.pageNumber,
        pageSize:10,
        userDataElasticsearch:{classification: this.classification, topicId: this.topicName ? this.topicName : null, isBookmark:true,isSpam: false},
        recently: this.valueText,
        oldestPost: this.valueOldestPost,
        interactive:this.valueInteractive,
        interactiveAscending: this.valueInteractiveUp,
        newsPost: this.newsPostCheckBox ? 101:0,
        facePost: this.facePostCheckBox ? 104: 0,
        faceComment: this.faceCommentCheckBox ? 105:0,
        youtube:this.youtubeCheckBox ? 106 : 0,
        youtubeComment:this.youtubeCheckBox ? 107 : 0,
        forum: this.forumCheckbox ? 111 : 0,
        forumComment:this.forumCheckbox ? 112 : 0,
        google: this.googleCheckbox ? 113 : 0,
        fromDate: this.dateRange.startDate,
        toDate: this.dateRange.endDate,
        content: this.formData.keyword,
        hahaCount: this.selectedHaha,
        likeCount: this.selectedLike,
        loveCount: this.selectedLove,
        sadCount: this.selectedSad,
        wowCount: this.selectedWow,
        careCount: this.selectedCare,
        angryCount: this.selectedAngry
      }

      if (!payload.newsPost && !payload.facePost && !payload.faceComment && !payload.youtube && !payload.youtubeComment && !payload.forum && !payload.forumComment && !payload.google) {
        if (this.showFacebookProfile != "false") payload.facePost = 104
        if (this.showFacebookComment != "false") payload.faceComment = 105
        if (this.showNewsPost != "false") payload.newsPost = 101
        if(this.showYoutube != 'false') {payload.youtube  = 106; payload.youtubeComment = 107}
        // if(this.showYoutubeComment != 'false') payload.youtubeComment  = 107
        if(this.showForum != 'false') {payload.forum = 111; payload.forumComment  = 112}
        // if(this.showForumComment != 'false') payload.forumComment =  112
        if(this.showGoogle != false) payload.google =  113
      }

      this.$report.post('/user-data/export-word-priority',payload).then(response =>{
        this.$vs.loading.close();
        if (!response || !response.data) return this.$vs.notify({
          text: this.$t('createReportError'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
        window.open(authConfig.reportDomain + "download/" + response.data + "?access_token=" + localStorage.getItem("access_token"), "_blank");
        this.$vs.loading.close();
        return this.$vs.notify({
          text: this.$t('articleBookmark.textDlData'),
          icon:'icon-alert',
          iconPack:'feather',
          color:'primary'
        })
      }).catch((err) =>{
        this.$vs.loading.close();
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      })
    }
  },
  async created(){
    this.dateRange.startDate = new Date(
      this.dateRange.startDate.setHours(0, 0, 0)
    );
    this.dateRange.endDate = new Date(
      this.dateRange.endDate.setHours(23, 59, 59)
    );
    this.initScreen()
    this.$eventBus.$on('i18n', (event) =>{
      this.initScreen();
    })
  },
  mounted(){
    let screen = window.screen.height;
    if (screen >= 1080){
      this.sizeContentByScreen = 15;
    }
  }
}
function getDates(startDate, endDate) {
  let dateArray = [];
  let currentDate = moment(startDate);
  let stopDate = moment(endDate);
  while (currentDate <= stopDate) {
    dateArray.push( {date : moment(currentDate).format('YYYY-MM-DD'),dateTime:formatterXTooltip(moment(currentDate).format('YYYY-MM-DD')), rowDatas: []} )
    currentDate = moment(currentDate).add(1, 'days');
  }
  return dateArray;
}
function getDatesEN(startDate, endDate) {
  let dateArray = [];
  let currentDate = moment(startDate);
  let stopDate = moment(endDate);
  while (currentDate <= stopDate) {
    dateArray.push( {date : moment(currentDate).format('YYYY-MM-DD'),dateTime:formatterXTooltipEN(moment(currentDate).format('YYYY-MM-DD')), rowDatas: []} )
    currentDate = moment(currentDate).add(1, 'days');
  }
  return dateArray;
}
function formatterXTooltip(strDate) {
  let newDate = new Date(strDate);
  if(isNaN(newDate.getTime())) return "";

  let day = newDate.getDay() === 0 ? "CN" : `THỨ ${newDate.getDay() + 1}`;
  let date = newDate.getDate()<10? '0'+ newDate.getDate():newDate.getDate();
  let month = (newDate.getMonth() + 1)<10? '0'+ (newDate.getMonth() + 1):(newDate.getMonth() + 1);

  return day + ", " + date + "/" + month + "/" + newDate.getFullYear();
}
function formatterXTooltipEN(strDate) {
  let newDate = new Date(strDate);
  if(isNaN(newDate.getTime())) return "";
  let weekdays = [ "Sunday", "Monday", "tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ];
  let day = weekdays[newDate.getDay()];
  let date = newDate.getDate()<10? '0'+ newDate.getDate():newDate.getDate();
  let month = (newDate.getMonth() + 1)<10? '0'+ (newDate.getMonth() + 1):(newDate.getMonth() + 1);

  return day + ", " + date + "/" + month + "/" + newDate.getFullYear();
}
function groupByKey(array, key) {
  return  Object.values(array
    .reduce((hash, obj) => {
      if(obj[key] === undefined) return hash;
      return Object.assign(hash, { [obj[key]]:( hash[obj[key]] || [] ).concat(obj)})
    }, {}))
}
</script>

<style scoped>
.timeLine-card{
  display: flex;
  flex-direction: column;
}
.card_view{
  background: #fff;
  display: block;
  -webkit-transition: all 0.3s ease-in-out;
  width: 100%;
  position: relative;
  display: flex;
  padding: 1px 0px;
}
.hide_title{
  font-size: 12px;
  font-weight: bold;
  height: 42px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2 !important; /* number of lines to show */
  -webkit-box-orient: vertical;
}
.header_tab{
  display: flex;
  flex-direction: column;
}
.title_tab{
  font-size: 14px;
  color: #626262;
  font-weight: 550;
}
.button-download-timeline{
  display: flex;
  justify-content: center;
}
</style>
